import Header from '@/components/Header';
import Hero from '@/components/Hero';
import About from '@/components/About';
import ClientMarquee from '@/components/ClientMarquee';
import ClientMarqueePlaceholder from '@/components/ClientMarqueePlaceholder';
import PortfolioGrid from '@/components/PortfolioGrid';
import Services from '@/components/Services';
import Process from '@/components/Process';
import FeedbackForm from '@/components/FeedbackForm';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      <About />
      <ClientMarquee />
      <PortfolioGrid />
      <Services />
      <Process />
      <ClientMarqueePlaceholder />
      <FeedbackForm />
      <Footer />
    </div>
  );
};

export default Index;
